import { render, staticRenderFns } from "./ReportIssueCreate.vue?vue&type=template&id=659f0636&scoped=true&"
import script from "./ReportIssueCreate.vue?vue&type=script&lang=js&"
export * from "./ReportIssueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f0636",
  null
  
)

export default component.exports